export function executeCallback<A extends unknown[], R>(
  callback: (...args: A) => R,
  ...payload: A
): void {
  Promise.resolve(payload).then((p) => callback(...p));
}
